import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './reportlist.css'; // Ensure custom CSS is imported


const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Reportpage = ({ userRole }) => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filteredReports, setFilteredReports] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [sortBy, setSortBy] = useState("");
    const history = useNavigate();

    const fetchReports = async () => {
        try {
            const response = await axios.get(`${BASE_URL}api/StockTransReports/GetAllSampleTransReports`);
            const sortedReports = response.data.sort((a, b) => 
                new Date(b.date1) - new Date(a.date1)
            );
            setReports(sortedReports);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userRole === 'Admin') {
            fetchReports();
        }
    }, [userRole]);

    useEffect(() => {
        if (filterText.trim() !== "") {
            const filtered = reports.filter(report =>
                report.vcmx1.toLowerCase().includes(filterText.toLowerCase())
            );
            setFilteredReports(filtered);
        } else {
            setFilteredReports(reports);
        }
    }, [filterText, reports]);

    useEffect(() => {
        if (sortBy !== "") {
            const sorted = [...filteredReports].sort((a, b) => {
                switch (sortBy) {
                    case "companyName":
                        return a.vcmx1.localeCompare(b.vcmx1);
                    case "contactPerson":
                        return a.vcmx2.localeCompare(b.vcmx2);
                    case "transactionType":
                        return a.vcmx7.localeCompare(b.vcmx7);
                    case "date":
                        return new Date(b.date1) - new Date(a.date1);
                    default:
                        return 0;
                }
            });
            setFilteredReports(sorted);
        }
    }, [sortBy, filteredReports]);

    if (userRole !== 'Admin') {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger" role="alert">
                    <h4>Access Denied</h4>
                    <p>You do not have permission to access this page. Admin access required.</p>
                </div>
            </div>
        );
    }

    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
    };

    const handleSortChange = (event) => {
        setSortBy(event.target.value);
    };

    const handleRowClick = (reportID) => {
        history(`/details/${reportID}`);
    };

    const formatDate = (dateStr) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateStr).toLocaleDateString(undefined, options);
    };

    return (
        <div className="report-page">
            <div className="main-content">
                <div className="container mt-5">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Reports</h3>
                            <div className="filter-sort-container">
                            <div className="row g-5">
                            
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="Filter" value={filterText} onChange={handleFilterChange} />
                                </div>
                                <div className="col-md-6">
                                    <select className="form-control" value={sortBy} onChange={handleSortChange}>
                                        <option value="">Sort By</option>
                                        <option value="companyName">Company Name</option>
                                        <option value="contactPerson">Contact Person</option>
                                        <option value="transactionType">Transaction Type</option>
                                        <option value="date">Date</option>
                                    </select>
                                </div>
                                </div>
                             
                            </div>
                        </div>
                        <div className="card-body">
                            {loading ? (
                                <p>Loading...</p>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead className="thead-dark">
                                            <tr>
                                                <th>Report ID</th>
                                                <th>Company Name</th>
                                                <th>Contact Person</th>
                                                <th>Telephone Number</th>
                                                <th>Address</th>
                                                <th>Transaction</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredReports.map(report => (
                                                <tr key={report.tdIndex} onClick={() => handleRowClick(report.vcmx5)}>
                                                    <td><Link to={`/details/${report.vcmx5}`}>{report.vcmx5}</Link></td>
                                                    <td>{report.vcmx1}</td>
                                                    <td>{report.vcmx2}</td>
                                                    <td>{report.vcmx3}</td>
                                                    <td>{report.vcmx4}</td>
                                                    <td>{report.vcmx7}</td>
                                                    <td>{formatDate(report.date1)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reportpage;
